var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemborsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 52,
    viewBox: "0 0 81 52",
    fill: "#99e9a3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7594 12.6075C58.7594 12.0661 59.0578 11.5688 59.5355 11.314L78.5931 1.14992C79.5696 0.629126 80.7489 1.33673 80.7489 2.44342L80.7489 38.7017C80.7489 39.2431 80.4505 39.7405 79.9728 39.9952L60.9152 50.1593C59.9387 50.6801 58.7594 49.9725 58.7594 48.8658L58.7594 12.6075Z",
    fill: "#99e9a3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1832 18.262C28.1832 17.7206 28.4816 17.2233 28.9593 16.9685L44.8759 8.47984C45.8524 7.95905 47.0317 8.66666 47.0317 9.77334L47.0317 40.3772C47.0317 40.9186 46.7333 41.4159 46.2556 41.6707L30.3391 50.1594C29.3626 50.6802 28.1832 49.9726 28.1832 48.8659L28.1832 18.262Z",
    fill: "#99e9a3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.748779 23.9164C0.748779 23.375 1.04717 22.8777 1.52487 22.6229L14.2994 15.8097C15.2759 15.2889 16.4553 15.9965 16.4553 17.1032L16.4553 42.0526C16.4553 42.594 16.1569 43.0913 15.6792 43.3461L2.90463 50.1593C1.92813 50.6801 0.748779 49.9725 0.748779 48.8658L0.748779 23.9164Z",
    fill: "#99e9a3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemborsIcon);
export default __webpack_public_path__ + "static/media/MemborsIcon.13cb3af49a4790daad93a971e46d26a9.svg";
export { ForwardRef as ReactComponent };